import * as Location from "expo-location";
import { useEffect, useState } from "react";

import {
  Location as ILocation,
  getLocationByAddress as findLocationByAddress,
} from "@/services/location";
import { logger } from "@/services/logger";

type useLocationProps = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useLocation = ({
  onError = () => {},
  onSuccess = () => {},
}: useLocationProps = {}) => {
  const [userLocation, setUserLocation] = useState<ILocation>(null);

  useEffect(() => {
    (async () => {
      try {
        const { status } = await Location.requestForegroundPermissionsAsync();
        if (status !== "granted") {
          return onError();
        }
        const location = await Location.getCurrentPositionAsync();
        setUserLocation(location.coords);
        return onSuccess();
      } catch (error) {
        logger.error(error);
        return onError();
      }
    })();
  }, []);

  const getLocationByAddress = async (address: string) => {
    try {
      const location = await findLocationByAddress(address);
      if (location?.latitude && location?.longitude) {
        setUserLocation(location);
      }
    } catch (error) {
      logger.error(error);
      setUserLocation(null);
    }
  };

  return {
    location: userLocation,
    getLocationByAddress,
  };
};
